export const resumePolicyPathNames = {
	resumePolicyDraft: 'resume-pd', // pd - policy draft
	resumeUWCReferredPolicy: 'resume-uwcrp', // uwcrp - under writer continuing referred policy
	resumeUCReferredPolicy: 'resume-ucrp', // ucrp - user continuing referred policy
	resumeUWCEndorsement: 'resume-uwcedr', // uwcedr - under writer continuing endorsement
	resumeUCQuotePolicy: 'resume-ucqp' // ucqp - user continuing quote policy
};
